export const ENGINEERING_EVIDENCE_EXPLORER = {
    title: "Engineering Evidence Explorer",
    liveUrl: "https://engineering-evidence-explorer.vercel.app/" as string | null,
    repositoryUrl: "https://github.com/JarrodSavard/Engineering-Evidence-Explorer",
    video: `${process.env.PUBLIC_URL}/videos/engineering-evidence-explorer-1080p.mp4`,
    poster: `${process.env.PUBLIC_URL}/videos/engineering-evidence-explorer-poster.jpg`,
    captions: `${process.env.PUBLIC_URL}/videos/engineering-evidence-explorer-en.vtt`,
};
